import unifiedLoggerClient from '@modules/eventStream/implementations/unifiedLoggerClient';
import { getBEDEV2ServiceBasePath, getRobloxDomain } from '@modules/utilities/constants/baseUrl';

import {
  RobloxOpencloudCloudauthenticationserviceV1CloudAuthenticationServiceAPIApi as CloudAuthServiceApi,
  V1ScopeTypesGetRequest,
} from '@rbx/clients/cloudAuthenticationService/v1';
import { Configuration } from '@rbx/clients';

export default class CloudAuthenticationClient {
  private cloudAuthApi: CloudAuthServiceApi;

  constructor(baseCloudAuthPath: string = getBEDEV2ServiceBasePath('cloud-authentication')) {
    const defaultConfig = new Configuration({
      robloxSiteDomain: getRobloxDomain(),
      basePath: baseCloudAuthPath,
      credentials: 'include',
      unifiedLogger: unifiedLoggerClient,
    });

    this.cloudAuthApi = new CloudAuthServiceApi(defaultConfig);
  }

  getScopeTypes(groupId?: number) {
    const request: V1ScopeTypesGetRequest = {
      groupId,
    };
    return this.cloudAuthApi.v1ScopeTypesGet(request);
  }
}
